import styled, { css } from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        padding: 40px;
        background-color: ${({ theme }) => theme.color.white};
        border-radius: 16px;
    `,

    "AreaDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;

        & > h2 {
            ${({ theme }) => theme.font.small_bold};

            & > span {
                color: ${({ theme }) => theme.color.major};
                ${({ theme }) => theme.font.small_bold};
            }
        }
    `,
    "AreaHeader": styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
    
        & > h2 {
            ${({ theme }) => theme.font.small_bold};

            & > span {
                color: ${({ theme }) => theme.color.major};
                ${({ theme }) => theme.font.small_bold};
            }
        }

        & > div {
            width: fit-content;
            display: flex;
            gap: 8px;
        }
    `,

    "ImgUploadDiv": styled.div`
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 16px;
    `,
    "ImgElement": styled.div`
        width: fit-content;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: end;
        flex-wrap: wrap;
        gap: 6px;

        & > img {
            width: 160px;
            height: 160px;
            object-fit: cover;
            object-position: center center;
            border-radius: 8px;
            cursor: pointer;
        }

        & > button {
            ${({ theme }) => theme.font.extra_small};
            display: flex;
            align-items: center;
            padding-top: 2px;
        }
    `,

    "SeriesDataDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;

        & > p {
            ${({ theme }) => theme.font.extra_small};
        }
    `,

    "PrizeTable": styled.table`

        & > tr {

            & > td {

            }
        }
    `,
    "TableHeader": styled.tr`
        background-color: ${({ theme }) => theme.color.major};

        & > td {
            ${({ theme }) => theme.font.extra_small_bold};
            color: ${({ theme }) => theme.color.white};
            padding: 12px 20px;
        }
    `,
    "ElemTd": styled.td`
        border: 1px solid ${({ theme }) => theme.color.grey2};
        background-color: ${({ theme }) => theme.color.grey1};

        & > input {
            width: 100%;
            ${({ theme }) => theme.font.extra_small};
            padding: 12px 20px;

            ${({ $head }) => $head && css`
                background-color: ${({ theme }) => theme.color.grey1};
                cursor: auto;
            `}
        }
    `,
    "RankTd": styled.td`
        width: 200px;
        min-width: 200px;
    `,
    "FitTd": styled.td`
        width: 100px;
        border: 1px solid ${({ theme }) => theme.color.grey2};
    `,
    "ControlDiv": styled.div`
        display: flex;
        justify-content: center;
        gap: 4px;

         & > button {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 24px;
            height: 24px;
            border-radius: 4px;
            background-color: ${({ theme }) => theme.color.grey2};
        }
    `,

    "AddBtn": styled.button`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        min-width: 20px;
        height: 20px;
        margin: 0 6px;
        background-color: ${({ theme }) => theme.color.grey2};
        border-radius: 9999px;
        align-self: center;

        & > img {
            width: 12px;
        }
    `
}